import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const STATS = [
  ["Your Cost", "$0", "Zero out of pocket. A sponsor covers the full $3,500 credit repair fee on your behalf."],
  ["Sponsor Puts In", "$3,500", "The credit repair fee per funding partner. Paid on your behalf by your sponsor."],
  ["Sponsor Gets Back", "$6,000", "Upon your successful funding, the sponsor receives $6,000 from the proceeds — a $2,500 return."],
  ["Timeline", "30 Days", "Credit repair takes 5–7 days. Full process from start to funded — within 30 days."],
];

const Stat = ({ label, value, desc, i }) => (
  <motion.div className="stat-box" data-testid={`stat-box-${i + 1}`} initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.7, delay: i * 0.09, ease: [0.16, 1, 0.3, 1] }}>
    <div className="stat-label">{label}</div>
    <div className="stat-value">{value}</div>
    <div className="stat-desc">{desc}</div>
  </motion.div>
);

export const Sponsor = () => (
  <Reveal className="card sponsor-card" data-testid="sponsor-card">
    <div className="sponsor-orb" />
    <div className="section-label">Client Sponsorship Program</div>
    <h2 style={{ maxWidth: 560 }}>Someone is covering your credit repair. Here is why.</h2>
    <p className="sponsor-intro">The Pay It Forward program is funded by sponsors — clients who have already completed our credit repair and funding process and chose to give someone else the same opportunity. They cover the cost of your credit repair upfront. You pay nothing out of pocket. Once you are funded, the sponsor receives their return from the proceeds.</p>
    <div className="stat-grid">
      {STATS.map(([l, v, d], i) => <Stat key={l} label={l} value={v} desc={d} i={i} />)}
    </div>
    <Reveal className="ink-panel" data-testid="sponsor-why-panel">
      <div className="mini-label">Why sponsors know they will be paid back</div>
      <p>We are not guessing. The qualification requirements we hold every applicant to — 7 open accounts, $10,000 or more in credit limits, no recent bankruptcies — are the exact same benchmarks our funding partners require. By the time credit is repaired, that client is already positioned to be funded. That is not a coincidence. It is by design.</p>
      <p>When a sponsor backs a client, they are not taking a risk. They are investing in a system that has already done the qualification work for them. Every client that enters this program enters because they were pre-screened to qualify.</p>
    </Reveal>
    <div className="become" data-testid="become-sponsor">
      <div className="mini-label">Want to become a sponsor yourself?</div>
      <p>Sponsors may back as many funding partners as they choose. Each one generates a separate $2,500 return. There is no cap. For clients who have already been through the program and have access to capital, this is a straightforward way to put funded money to work while helping someone else get the same opportunity you did.</p>
      <p>Submit an application and mention your interest in sponsoring. Our team will walk you through both paths on your call.</p>
    </div>
  </Reveal>
);
